import * as types from '../mutation-types'
import { api } from '@/modules/api'
import * as R from 'ramda'

const state = {
  form: null
}

const getters = {
  getFormData: R.prop('form'),
  getFields: R.path(['form', 'fields'])
}

const actions = {
  async getInterpritationFormData ({ commit }, type) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.get(api.form.getFormByType(type))
      const { data: { form } } = response
      commit(types.SAVE_INTERPRITATION_FORM, form)
      return form
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Unable to get information about this form')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SAVE_INTERPRITATION_FORM] (state, data) {
    state.form = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/formInterpritation.js